import styled from 'styled-components'

import { Label } from 'components/UIElements/Label'

import { AssetIcon as UIAssetIcon } from '../AssetIcon'

export type AssetDataSize = 'small' | 'normal' | 'big'

export const Wrapper = styled.div<{ full?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 8px;

  justify-content: ${(props) => (props.full ? 'space-between' : 'flex-start')};
`

export const AssetInfo = styled.div`
  display: flex;
  align-items: center;
`

export const AssetIcon = styled(UIAssetIcon)``

export const TickerRow = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 55px;
`

export const TickerLabel = styled(Label).attrs({
  textTransform: 'uppercase',
  weight: '600',
})`
  min-width: 50px;
  padding-left: 10px;
  line-height: normal;
`

export const TypeLabel = styled(Label).attrs({
  textTransform: 'uppercase',
  size: 'small',
})`
  min-width: 50px;
  padding-left: 10px;
  line-height: normal;
`

export const AmountLabel = styled(Label).attrs({
  textTransform: 'uppercase',
  weight: '400',
  color: 'light',
})`
  padding-left: 10px;
  padding-right: 4px;
`

export const PriceLabel = styled(Label).attrs({
  textTransform: 'uppercase',
  weight: 'normal',
  color: 'light',
})`
  padding-left: 10px;
`
